import { useLang } from '@/i18n/LanguageContext';

const HOVER_BLUE = '#0057FF';

export default function LanguageToggle({
  variant = 'nav',
}: {
  variant?: 'nav' | 'footer';
}) {
  const { lang, setLang } = useLang();

  const baseStyle: React.CSSProperties = {
    fontFamily: "'IBM Plex Mono', monospace",
    fontSize: variant === 'nav' ? '0.72rem' : 'var(--type-caption)',
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    transition: 'color 0.2s ease',
  };

  const optStyle = (active: boolean): React.CSSProperties => ({
    ...baseStyle,
    color: active ? 'var(--lp-ink)' : 'var(--lp-muted)',
    opacity: active ? 1 : 0.7,
  });

  return (
    <span
      aria-label="language toggle"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
    >
      <button
        type="button"
        onClick={() => setLang('pt')}
        style={optStyle(lang === 'pt')}
        onMouseEnter={(e) => {
          if (lang !== 'pt') (e.currentTarget as HTMLButtonElement).style.color = HOVER_BLUE;
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.color = lang === 'pt' ? 'var(--lp-ink)' : 'var(--lp-muted)';
        }}
        aria-pressed={lang === 'pt'}
      >
        PT
      </button>
      <span
        style={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: variant === 'nav' ? '0.72rem' : 'var(--type-caption)',
          color: 'var(--lp-muted)',
          opacity: 0.5,
        }}
      >
        /
      </span>
      <button
        type="button"
        onClick={() => setLang('en')}
        style={optStyle(lang === 'en')}
        onMouseEnter={(e) => {
          if (lang !== 'en') (e.currentTarget as HTMLButtonElement).style.color = HOVER_BLUE;
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.color = lang === 'en' ? 'var(--lp-ink)' : 'var(--lp-muted)';
        }}
        aria-pressed={lang === 'en'}
      >
        EN
      </button>
    </span>
  );
}
